"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.PrevisuPasse = exports.getDebordementDouble = exports.getFiletSize = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _PrevisuFenetrePasse = _interopRequireDefault(require("./PrevisuFenetrePasse"));

var getFiletSize = function getFiletSize() {
  return 2;
};

exports.getFiletSize = getFiletSize;

var getDebordementDouble = function getDebordementDouble() {
  return 4;
};

exports.getDebordementDouble = getDebordementDouble;

var PrevisuPasse = function PrevisuPasse(props) {
  var cmToPx = props.cmToPx,
      pageProduit = props.pageProduit,
      product = props.product,
      aspectProduit = props.aspectProduit;
  var pp = product;
  var isDouble = typeof pp.pad_passe_hexa !== "undefined";
  var ppOuverture = {
    width: pageProduit.largeur * cmToPx + getFiletSize() * 2 + (isDouble ? getDebordementDouble() * 2 + getFiletSize() * 2 : 0),
    height: pageProduit.hauteur * cmToPx + getFiletSize() * 2 + (isDouble ? getDebordementDouble() * 2 + getFiletSize() * 2 : 0),
    borderRadius: typeof pageProduit.pp.forme !== "undefined" && pageProduit.pp.forme === "ovale" ? 200 : 0,
    position: "absolute"
  };
  var ppOuvertureDouble = {
    width: pageProduit.largeur * cmToPx + getFiletSize() * 2 + getDebordementDouble() * 2,
    height: pageProduit.hauteur * cmToPx + getFiletSize() * 2 + getDebordementDouble() * 2,
    position: "absolute"
  };
  var height = (pageProduit.pp.margeH + pageProduit.pp.margeB + pageProduit.hauteur * pageProduit.pp.ouvertures[1] + pageProduit.pp.interH * (pageProduit.pp.ouvertures[1] - 1)) * cmToPx;
  var width = (pageProduit.largeur * pageProduit.pp.ouvertures[0] + (pageProduit.pp.margeG + pageProduit.pp.margeD) + pageProduit.pp.interL * (pageProduit.pp.ouvertures[0] - 1)) * cmToPx;
  var largeurSujetS = {
    position: "absolute",
    left: props.pageProduit.largeur * cmToPx / 2 - 30,
    top: (pageProduit.pp.margeT + pp.margeH) * cmToPx,
    background: "white",
    zIndex: 20,
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    textAlign: "center",
    padding: "0 10px",
    fontSize: "13px",
    fontWeight: "bold"
  };
  var hauteurSujetS = {
    position: "absolute",
    left: -16,
    top: props.pageProduit.hauteur * cmToPx / 2 - 10,
    transform: "rotate(-90deg)",
    background: "white",
    zIndex: 20,
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    textAlign: "center",
    padding: "0 10px",
    fontSize: "13px",
    fontWeight: "bold"
  };
  var fullWidthCmS = {
    position: "absolute",
    left: width / 2 - 30,
    top: -pageProduit.pp.margeH * cmToPx - 19,
    zIndex: 20,
    color: "white",
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    textAlign: "center",
    padding: "0 10px",
    fontSize: "13px",
    fontWeight: "bold"
  };
  var fullHeightCmS = {
    position: "absolute",
    left: -pageProduit.pp.margeG * cmToPx - 36,
    top: height / 2 - 10,
    transform: "rotate(-90deg)",
    zIndex: 20,
    color: "white",
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    textAlign: "center",
    padding: "0 10px",
    fontSize: "13px",
    fontWeight: "bold"
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: ((pageProduit.hauteur + pageProduit.pp.margeH + pageProduit.pp.margeB) * pageProduit.pp.ouvertures[1] + pageProduit.pp.ouvertures[1] * (pageProduit.pp.margeH + pageProduit.pp.margeB)) * cmToPx,
      filter: typeof pageProduit.pp.forme !== "undefined" && pageProduit.pp.forme === "ovale" ? "" : "drop-shadow(-1px 3px 3px rgba(50, 50, 0, 0.4))",
      width: "100%",
      textAlign: "center"
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pp is-relative noisy",
    style: {
      width: (pageProduit.largeur * pageProduit.pp.ouvertures[0] + (pageProduit.pp.margeG + pageProduit.pp.margeD) + pageProduit.pp.interL * (pageProduit.pp.ouvertures[0] - 1)) * cmToPx,
      marginLeft: "auto",
      marginRight: "auto",
      borderRadius: typeof pageProduit.pp.forme !== "undefined" && pageProduit.pp.forme === "ovale" ? 200 : 0,
      borderTop: pageProduit.pp.margeH * cmToPx + "px solid " + pp.pa_passe_hexa,
      borderBottom: pageProduit.pp.margeB * cmToPx + "px solid " + pp.pa_passe_hexa,
      borderLeft: pageProduit.pp.margeG * cmToPx + "px solid " + pp.pa_passe_hexa,
      borderRight: pageProduit.pp.margeD * cmToPx + "px solid " + pp.pa_passe_hexa,
      background: pp.pa_passe_hexa,
      height: height
    }
  }, props.showDimensions && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    style: fullWidthCmS,
    id: "dimLargeurF",
    className: "has-background-primary"
  }, parseFloat(parseFloat(width / cmToPx).toFixed(2)), "cm"), /*#__PURE__*/_react.default.createElement("div", {
    style: fullHeightCmS,
    id: "dimHauteurF",
    className: "has-background-primary"
  }, parseFloat(parseFloat(height / cmToPx).toFixed(2)), "cm"), /*#__PURE__*/_react.default.createElement("div", {
    style: largeurSujetS,
    id: "dimLargeur"
  }, parseFloat(parseFloat(props.pageProduit.largeur).toFixed(2)), "cm"), /*#__PURE__*/_react.default.createElement("div", {
    style: hauteurSujetS,
    id: "dimHauteur"
  }, parseFloat(parseFloat(props.pageProduit.hauteur).toFixed(2)), "cm")), Array(pageProduit.pp.ouvertures[1]).fill(0).map(function (c, cI) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: cI
    }, Array(pageProduit.pp.ouvertures[0]).fill(0).map(function (r, rI) {
      return /*#__PURE__*/_react.default.createElement("div", {
        key: cI + "-" + rI,
        style: (0, _extends2.default)({}, ppOuverture, {
          left: (pageProduit.largeur + pageProduit.pp.interL) * rI * cmToPx - getFiletSize() - (isDouble ? getFiletSize() + getDebordementDouble() : 0),
          top: (pageProduit.hauteur + pageProduit.pp.interH) * cI * cmToPx - getFiletSize() - (isDouble ? getFiletSize() + getDebordementDouble() : 0)
        })
      }, /*#__PURE__*/_react.default.createElement(_PrevisuFenetrePasse.default, {
        couleurInterieur: isDouble ? "transparent" : props.couleurInterieur,
        couleurAme: pp.pa_passe_ame_hexa,
        image: null,
        ppOuverture: ppOuverture,
        pp: pageProduit.pp
      }), isDouble && /*#__PURE__*/_react.default.createElement("div", {
        style: (0, _extends2.default)({}, ppOuvertureDouble, {
          left: getDebordementDouble(),
          top: getDebordementDouble(),
          border: getFiletSize() + "px solid " + pp.pad_passe_hexa
        })
      }, /*#__PURE__*/_react.default.createElement(_PrevisuFenetrePasse.default, {
        couleurInterieur: props.couleurInterieur,
        couleurAme: pp.pad_passe_ame_hexa,
        image: null,
        ppOuverture: ppOuverture,
        pp: pageProduit.pp
      })));
    }));
  })));
};

exports.PrevisuPasse = PrevisuPasse;
PrevisuPasse.defaultProps = {
  size: 90,
  showDimensions: false,
  couleurInterieur: "#FFF",
  dimSaisies: null
};
PrevisuPasse.propTypes = {
  pageProduit: _propTypes.default.object.isRequired,
  product: _propTypes.default.object.isRequired,
  showDimensions: _propTypes.default.bool,
  size: _propTypes.default.number,
  cmToPx: _propTypes.default.number,
  couleurInterieur: _propTypes.default.string,
  aspectProduit: _propTypes.default.object
};
var _default = PrevisuPasse;
exports.default = _default;